<template>
    <LogIn />
  </template>
  
  <script>
    import LogIn from '@/components/LogIn.vue'
  
    export default {
      name: 'LogInView',
  
      components: {
        LogIn,
      },
    }
  </script>
  
  <style lang="scss" scoped>
  //
  </style>